import React from 'react';
import Rollbar from '../../utils/RollbarTracking'
import axios from 'axios'
import { toast } from 'react-toastify';

class ResetPassword extends React.Component {
   state = {
      token: this.props.token,
      password: ''
   }

   handleChange(event) {
      this.setState({ [event.target.name]: event.target.value })
   }

   resetPassword() {
      axios.post('/auth/reset', {
         token: this.state.token,
         password: this.state.password
      })
         .then(data => {
            console.log(data)
            this.props.showLogin()
         })
         .catch(err => {
            console.log(err)
            Rollbar.error(err)
            toast.error('Failed to reset password')
         })
   }

   render() {
      return (
         <div className="text-center">
            <form className="form-signin" onSubmit={e => e.preventDefault()}>
               <img className="mb-4" src="/logo.png" alt="" width="300" />
               <h1 className="h3 mb-3 font-weight-normal">Reset Password</h1>
               <label for="inputPassword" className="sr-only">Password</label>
               <input type="password" id="inputPassword" className="form-control" placeholder="Password" name="password" value={this.state.password} onChange={this.handleChange.bind(this)} />
               <button className="mt-3 btn btn-lg btn-primary btn-block" type="submit" onClick={this.resetPassword.bind(this)}>Reset</button>
               <p className="mt-3 mb-3 text-muted">&copy; {new Date().getFullYear()} OrderFresh</p>
            </form>
         </div>
      )
   }
}

export default ResetPassword;
